import { IonButton, IonCol, IonRow, IonText } from '@ionic/react';
import { SimpleProduct } from '../../types/product.type';
import ProductCard from './ProductCard';
import { splitInHalf } from '../../functions/string.functions';
import { appSubDir } from '../../configs/app';
import ProductCardSkeletonLoading from './ProductCardSkeletonLoading';
import { getProductImageUrl } from '../../functions/product.functions';
import './ProductsHorizontal.scss';

type Props = {
    title: string
    hideHeader?: boolean
    splitTitle?: boolean
    products?: SimpleProduct[]
    loading: boolean
    routerLink?: string
}
const ProductsGrid: React.FC<Props> = ({ title, products, hideHeader, loading, routerLink, splitTitle }) => {
    if (!products) {
        return null
    }
    return (
        <section className='h-products mb-50' style={{ padding: "0 10px" }}>
            {!hideHeader && (
                <div className="category-section-header">
                    <h2 className="category-title">{title}</h2>
                </div>
            )}

            {loading && <div className='product-grid'>
                {[...Array(18)].map((item, index) => <ProductCardSkeletonLoading key={index} />)}
            </div>}

            {!loading && products && <div className='product-grid'>
                {products.map((item, index) => <ProductCard key={index} product={item} />)}
            </div>}

            {!loading && products && products.length > 0 && (
                <div className="view-all-container">
                    <IonButton routerLink={routerLink || (appSubDir + "shop")} className="view-all-btn">
                        View All
                    </IonButton>
                </div>
            )}
        </section>
    );
};

export default ProductsGrid;
